import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class GroupService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/groups', query);
  }

  create(body: any) {
    return this.post('/v2/group', body);
  }

  find(id) {
    return this.get('/v2/group/' + id);
  }

  update(body) {
    return this.put('/v2/updateGroup', body);
  }

  _delete(id) {
    return this.delete('/v2/group/' + id);
  }

  allGroup(query?: any) {
    return this.get('/v2/all-group', query);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Group.service.ts